import React, { useContext, useEffect } from 'react';
import Modal from 'react-modal';
import Lottie from 'lottie-react';
import loader from '../../../assets/lottie/loader.json';
import { contextData } from '../../../context/ContextProvider';
import "./Loader.css";
const Loader = (props) => {
    const { loading } = useContext(contextData) || {};
    // || {};
    const style = {
        // width: "25%",
        width: "45%",
        margin: "0 auto",
    };


    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 100000
        },
        overlay: {
            zIndex: 100000 // Set a higher zIndex for the first modal
        },
    };
    useEffect(() => {
        const inner = document.getElementById("custom-loader");
        inner?.parentElement?.classList.add("custom-modal-container");
    }, [])

    return (

        <Modal isOpen={loading} style={customStyles} >
            <div id="custom-loader" data-testid='custom-loader'>
                <Lottie animationData={loader} style={style} />
            </div>
        </Modal>
    )
}

export default Loader;